export function getPostAuthRoute(user: {
  application_status: string
  application_submission_type: string
  application_video_url: string
  application_written_why_trip: string
  application_written_limitations: string
  application_written_experience_goal: string
  application_written_why_generation_one: string
}): '/community' | '/apply/confirmation' | '/apply' {
  if (user.application_status === 'approved') return '/community'
  if (hasSubmittedApplication(user)) return '/apply/confirmation'
  return '/apply'
}

// eslint-disable-next-line complexity
export function hasSubmittedApplication(user: {
  application_submission_type: string
  application_video_url: string
  application_written_why_trip: string
  application_written_limitations: string
  application_written_experience_goal: string
  application_written_why_generation_one: string
}): boolean {
  if (user.application_submission_type?.trim()) return true
  if (user.application_video_url?.trim()) return true

  return (
    user.application_written_why_trip?.trim().length > 0 ||
    user.application_written_limitations?.trim().length > 0 ||
    user.application_written_experience_goal?.trim().length > 0 ||
    user.application_written_why_generation_one?.trim().length > 0
  )
}
